// Confirmed 2026-07-10 — GET /api/hr/workflows/meta returns all 7 modules; nothing is filtered
// server-side. PROCUREMENT and ASSET were missing from this list (frontend-only gap), which
// hid them from the module picker/coverage badges even though they're real, routable modules —
// PROCUREMENT in particular had zero workflow configured at all until this session.
export const modules = [
  "LEAVE",
  "CLAIM",
  "INVENTORY",
  "REQUISITION",
  "TRAINING",
  "PROCUREMENT",
  "ASSET",
] as const;

// REQUISITION (Staff Requisition — in-stock goods/assets) and PROCUREMENT (Purchase
// Requisition — external procurement) are two unrelated entities that both involve the word
// "requisition"; generic label() would render both as ambiguous single words ("Requisition" /
// "Procurement"). Use this wherever a module *code* is shown to a human in the Workflow admin
// screens, instead of label(), to keep the two unmistakably separate.
const MODULE_LABELS: Record<string, string> = {
  REQUISITION: "Staff Requisition",
  PROCUREMENT: "Purchase Requisition",
  ASSET: "Asset Disposal",
};

export function moduleLabel(value?: string | null) {
  if (!value) return "-";
  return MODULE_LABELS[value] ?? label(value);
}

export const approverTypes = [
  "APPLICANT_DEPARTMENT_HEAD",
  "APPLICANT_MANAGING_DIRECTOR",
  "ROLE_BASED_APPROVER",
  "SPECIFIC_USER",
] as const;

export const timeoutActions = [
  "DO_NOTHING",
  "ESCALATE_TO_ANOTHER_APPROVER",
  "AUTO_APPROVE",
  "AUTO_REJECT",
  "REASSIGN_TO_ANOTHER_APPROVER",
] as const;

export const approvalModes = [
  "SINGLE_APPROVER",
  "ALL_MUST_APPROVE",
  "ANY_ONE_CAN_APPROVE",
] as const;

// Order mirrors a typical approval chain (reviewer -> verifier -> confirmer -> final approver),
// though any step can use any verb independently.
export const stepVerbs = [
  "REVIEW",
  "VERIFY",
  "CONFIRM",
  "APPROVE",
] as const;

export function label(value?: string | null) {
  if (!value) return "-";

  return value
    .replaceAll("_", " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}